import React, { forwardRef } from 'react';
import strFunc from '@/lib/lyg/string';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios/index";
import RadioListArea from "@/pcomponents/common/crud/write/radio/radio_arr";

const ParentArea = forwardRef((props: any, ref) => {
  let myProps = {
    select_mcomp_data: {
      mcomp_seq: "",
      api_key: "",
      api_user_seq: "",
    },
    is_update: false,
    info: {},
    set_info: (inData: any) => { },
    is_view_mode: false,
    parentArr: [],
    setParentArr: (inData: any) => { },
    on_change_parent_hp: (inData: any) => { },
    ...props,
  };
  let info = myProps.info;
  let is_view_mode = myProps.is_view_mode;
  let select_mcomp_data = myProps.select_mcomp_data;
  let parentArr = myProps.parentArr;
  for(let i=0;i<parentArr.length;i++){
    parentArr[i].a_is_attend_sms="";
    parentArr[i].a_is_supply_sms="";
  }
  
  let default_par_row = {
    "a_seq": "",
    "a_user_phone": "",
    "a_user_id": "",
    "a_user_pw": "",
    "a_relation": "모",
    "a_order": "0",
    "a_is_attend_sms": "",
    "a_is_attend_push": "",
    "a_is_attend_katalk": "1",
    "a_is_supply_sms": "",
    "a_is_supply_push": "",
    "a_is_supply_katalk": "1",
    "a_is_daily_report_push": "",
    "a_is_daily_report_katalk": "1",
  };

  const handleInputChangeStu = (inData: any) => {
    let opt_obj = {
      name: "",
      value: "",
      ...inData
    };
    let value = opt_obj.value;
    const name = opt_obj.name;

    myProps.set_info({
      ...info,
      ...{ [name]: value }
    });
  };

  const handleInputChange = (event: any, idx: number) => {
    const target = event.target;
    let value = target.value;
    const name = target.name;
    if (target.type === 'checkbox' || target.type === 'radio') {
      value = "";
      if (target.checked) {
        value = target.value;
      }
    }
    if (name == "a_user_phone") {
      value = strFunc.autoHypenPhone(value);
      checkPhoneOfParentUser(value, idx);
      if (idx == 0) {
        if (value.length >= 13) {
          myProps.on_change_parent_hp(value);
        }
      }
    }
    let tmpParentArr = [...parentArr];
    tmpParentArr[idx][name] = value;
    myProps.setParentArr(tmpParentArr);
  };

  const checkPhoneOfParentUser = (phone: string, idx: number) => {
    if (phone.length != 13) {
      return false;
    }
    if (parentArr[idx].a_seq == "") {

      //이미 있는지 체크
      let checkPhoneFormData: any = {
        "s_phone": phone,
        "s_grade": "parent",
        "is_need_count": "",
        "is_need_info_arr": "1",
        "is_no_limit": "1",
      };
      if (!strFunc.is_empty(select_mcomp_data.api_key)
        && !strFunc.is_empty(select_mcomp_data.api_user_seq)) {
        checkPhoneFormData["api_key"] = select_mcomp_data.api_key;
        checkPhoneFormData["api_user_seq"] = select_mcomp_data.api_user_seq;
      }
      my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/list', checkPhoneFormData, get_axios_data())
        .then((response) => {
          if (response.data["result"] === "true") {
            //props.callback();
            if (response.data["data"]["info_arr"].length != 0) {
              let tmpParentArr: any = [...parentArr];
              let u_info = response.data["data"]["info_arr"][0];
              if (confirm("해당 핸드폰은 이미있는 회원이 있습니다. " + u_info["a_user_name"] + " 님이 맞습니까?")) {
                tmpParentArr[idx]["a_seq"] = u_info["a_seq"];
                tmpParentArr[idx]["a_user_id"] = u_info["a_user_id"];
                if (idx == 0) {
                  if (tmpParentArr[idx]["a_user_phone"].length >= 13) {
                    myProps.on_change_parent_hp(tmpParentArr[idx]["a_user_phone"]);
                  }
                }
              } else {
                tmpParentArr[idx]["a_user_phone"] = "";
              }
              myProps.setParentArr([
                ...tmpParentArr
              ]);
            }
          }
        });
    }
  };

  const addRow = () => {
    if (parentArr.length >= 2) {
      alert("보호자는 2명까지 등록 가능합니다.");
      return false;
    }
    let tmpParentArr = [...parentArr];
    tmpParentArr.push({
      ...default_par_row,
      "a_order": tmpParentArr.length,
    });
    myProps.setParentArr([
      ...tmpParentArr
    ]);
  };

  const setOrderNumAuto = () => {
    let tmpParentArr = [...parentArr];
    for (let i = 0; i < tmpParentArr.length; i++) {
      tmpParentArr[i].a_order = i;
    }
    myProps.setParentArr([
      ...tmpParentArr
    ]);
  };

  const delRow = (idx: number) => {
    let tmpParentArr = [...parentArr];
    if (tmpParentArr[idx].a_seq == "") {
      //저장전에는 바로삭제
      delRowByIdx(idx);
    } else {
      if (!confirm("부모회원을 삭제 하시겠습니까?")) {
        return false;
      }
      let delFormJsonData: any = {
        "user_seq": tmpParentArr[idx].a_seq
      };
      if (!strFunc.is_empty(select_mcomp_data.api_key)
        && !strFunc.is_empty(select_mcomp_data.api_user_seq)) {
        delFormJsonData["api_key"] = select_mcomp_data.api_key;
        delFormJsonData["api_user_seq"] = select_mcomp_data.api_user_seq;
      }
      my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/delete_one', delFormJsonData, get_axios_data())
        .then((response) => {
          if (response.data["result"] === "true") {
            delRowByIdx(idx);
          } else {
            alert(response.data["msg"]);
          }
        });
    }
  };

  const delRowByIdx = (idx: number) => {
    let tmpParentArr = [...parentArr];
    let newParentArr = [];
    for (let i = 0; i < tmpParentArr.length; i++) {
      if (i != idx) {
        newParentArr.push(tmpParentArr[i]);
      }
    }
    myProps.setParentArr([
      ...newParentArr
    ]);
  };

  const changeRowOrder = (now_idx: number, change_idx: number) => {
    if (change_idx < 0) {
      return false;
    }
    if (change_idx >= parentArr.length) {
      return false;
    }
    let tmpParentArr = [...parentArr];
    let now_row = tmpParentArr[now_idx];
    let change_row = tmpParentArr[change_idx];
    tmpParentArr[now_idx] = change_row;
    tmpParentArr[change_idx] = now_row;
    for (let i = 0; i < tmpParentArr.length; i++) {
      tmpParentArr[i].a_order = i;
    }
    myProps.setParentArr([
      ...tmpParentArr
    ]);
    return true;
  }

  return (
    <div>
      <div className="list-table-div mt-1">
        <table>
          <colgroup>
            <col width="90px" />
            <col width="110px" />
            <col width="80px" />
            <col width="60px" />
            <col width="150px" />
            <col width="210px" />
            <col width="20px" />
          </colgroup>
          <thead>
            <tr>
              <th>
                보호자
                <span className="emphasis_star">*</span>
                <button className="btn btn-circle-yellowish2 ml-2" onClick={addRow}>+</button>
              </th>
              <th>연락처</th>
              <th>아이디</th>
              <th>비밀번호</th>
              <th>알림</th>
              <th>현금영수증발급</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {parentArr.map((item: any, idx: number) => {
              let par_grade_str = "보호자";
              if (idx != 0) {
                par_grade_str = "기타보호자";
              }

              let stu_cash_receipt_order = info.a_cash_receipt_order;
              if (strFunc.is_empty(stu_cash_receipt_order)) {
                stu_cash_receipt_order = 0;
              }
              let is_cash_receipt_row = false;
              if (idx == stu_cash_receipt_order) {
                is_cash_receipt_row = true;
              }

              return (
                <React.Fragment key={idx}>
                  <tr>
                    <td className="text-center" title={item.a_user_name}>
                      <div>
                        {par_grade_str}
                      </div>
                      <div>
                        <input type='text' className='row-input' name="a_user_name" value={item.a_user_name} onChange={(e: any) => { handleInputChange(e, idx); }}
                          autoComplete='off' style={{ width: "100px" }} />
                      </div>
                    </td>
                    <td className="text-center">
                      <input type="text" className="px-1" name="a_user_phone" value={item.a_user_phone} onChange={(e: any) => { handleInputChange(e, idx); }} autoComplete="off" style={{ width: "99%" }} />
                    </td>
                    <td className="text-center">
                      <input type="text" className="px-1" name="a_user_id" value={item.a_user_id} onChange={(e: any) => { handleInputChange(e, idx); }} autoComplete="new-password" style={{ width: "99%" }} />
                    </td>
                    <td className="text-center">
                      <input type="password" className="px-1" name="a_user_pw" value={item.a_user_pw} onChange={(e: any) => { handleInputChange(e, idx); }} autoComplete="new-password" style={{ width: "99%" }} />
                    </td>
                    <td className="text-center">
                      <table>
                        <tbody>
                          <tr>
                            <td className="text-center" style={{ border: 0, borderBottom: "1px solid #ddd" }}>출결</td>
                            <td>
                              <div className="my_flex_center">
                                <label>
                                  <input type="checkbox" name="a_is_attend_push" value="1" onChange={(e: any) => { handleInputChange(e, idx); }}
                                    checked={item.a_is_attend_push == "1"} />
                                  <span className="ml-1">푸시</span>
                                </label>
                                <label>
                                  <input type="checkbox" name="a_is_attend_katalk" value="1" onChange={(e: any) => { handleInputChange(e, idx); }}
                                    checked={item.a_is_attend_katalk == "1"} />
                                  <span className="ml-1">알림톡</span>
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td className="text-center" style={{ border: 0 }} >수납</td>
                            <td>
                              <div className="my_flex_center">
                                <label>
                                  <input type="checkbox" name="a_is_supply_push" value="1" onChange={(e: any) => { handleInputChange(e, idx); }}
                                    checked={item.a_is_supply_push == "1"} />
                                  <span className="ml-1">푸시</span>
                                </label>
                                <label>
                                  <input type="checkbox" name="a_is_supply_katalk" value="1" onChange={(e: any) => { handleInputChange(e, idx); }}
                                    checked={item.a_is_supply_katalk == "1"} />
                                  <span className="ml-1">알림톡</span>
                                </label>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td className="text-center" style={{ border: 0 }} >데일리</td>
                            <td>
                              <div className="my_flex_center">
                                <label>
                                  <input type="checkbox" name="a_is_daily_report_push" value="1" onChange={(e: any) => { handleInputChange(e, idx); }}
                                    checked={item.a_is_daily_report_push == "1"} />
                                  <span className="ml-1">푸시</span>
                                </label>
                                <label>
                                  <input type="checkbox" name="a_is_daily_report_katalk" value="1" onChange={(e: any) => { handleInputChange(e, idx); }}
                                    checked={item.a_is_daily_report_katalk == "1"} />
                                  <span className="ml-1">알림톡</span>
                                </label>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td>
                      <div className="my_flex_left">
                        <input type="checkbox" name="a_cash_receipt_order" value="1" checked={stu_cash_receipt_order == idx}
                          onChange={(e: any) => {
                            handleInputChangeStu({ name: "a_cash_receipt_order", value: idx });
                          }} />
                        <span>
                          <input type="text" className="row-input" name="a_cash_receipt_num"
                            value={is_cash_receipt_row ? info.a_cash_receipt_num : ""}
                            style={{ width: "110px" }}
                            onChange={(e: any) => {
                              if (is_cash_receipt_row) {
                                handleInputChangeStu({ name: "a_cash_receipt_num", value: e.target.value });
                              }
                            }}
                            placeholder="발급번호"
                          />
                        </span>
                        <span>
                          <RadioListArea
                            valueTextArr={[
                              { value: "소득공제용", text: "소득공제용" },
                              { value: "지출증빙용", text: "지출증빙용" },
                            ]}
                            value={is_cash_receipt_row ? info.a_cash_receipt_sort : ""}
                            name="a_cash_receipt_sort"
                            handleInputChange={(e: any) => {
                              if (is_cash_receipt_row) {
                                handleInputChangeStu({ name: "a_cash_receipt_sort", value: e.target.value });
                              }
                            }}
                          ></RadioListArea>
                        </span>
                      </div>
                    </td>
                    <td className="text-center">
                      <div className="btn-box-center">
                        <span>
                          {idx != 0 &&
                            <button className='btn-s btn-dark' onClick={() => { changeRowOrder(idx, idx - 1); }}>▲</button>
                          }
                          {idx != parentArr.length - 1 &&
                            <button className='btn-s btn-dark ml-1' onClick={() => { changeRowOrder(idx, idx + 1); }}>▼</button>
                          }
                        </span>
                        <button className="btn-s btn-red" onClick={() => { delRow(idx); }}>삭제</button>
                      </div>
                    </td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
});
export default ParentArea;